import { render } from "./ImportExportComponent.vue?vue&type=template&id=78a6e371"
import script from "./ImportExportComponent.vue?vue&type=script&lang=js"
export * from "./ImportExportComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__